import * as React from 'react';

interface Props {
    country: CountryAnswer;
    isRoundInterval: boolean;
}

const MapAnswer: React.SFC<Props> = function (props: Props): JSX.Element | null {
    if (props.isRoundInterval === false) {
        return null;
    }

    return (
        <div className="map-answer">
            <div>{props.country.metricDisplay}</div>
        </div>
    );
};

export default MapAnswer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/map-answer/map-answer.tsx